<template>
  <base-sheet :visible="visible" @close="$emit('close')">
    <p v-if="course" class="vxl-sheet__label">{{ course.name }}</p>

    <p v-if="course && !hasAccess" class="vxl-sheet__alert">
      <i class="material-icons">block</i>
      Acesso suspenso — você pode remover os arquivos pra liberar espaço.
    </p>

    <button v-if="hasAccess" class="vxl-sheet__row" @click="onAction('open-course')">
      <span class="vxl-sheet__row-icon" :style="{ color: $theme.primaryColor }">▶</span>
      <span>Acessar curso</span>
    </button>

    <button class="vxl-sheet__row vxl-sheet__row--danger" @click="onAction('remove-all')">
      <i class="material-icons vxl-sheet__row-icon">delete_outline</i>
      <span>Remover todos os downloads</span>
    </button>

    <button class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('close')">
      Cancelar
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

export default {
  name: 'CourseActionsSheet',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    course: { type: Object, default: null }
  },
  computed: {
    // Default true mantém o comportamento antigo (todos os cursos passados
    // tinham acesso implícito). false só quando o getter downloadedCourses
    // explicitamente marca o curso como sem acesso (enroll some da listagem
    // do backend após revogação).
    hasAccess () {
      return !this.course || this.course.hasAccess !== false;
    }
  },
  methods: {
    onAction (name) {
      if (!this.course) return;
      this.$emit(name, { enrollId: this.course.enrollId, name: this.course.name });
      this.$emit('close');
    }
  }
};
</script>
